// extracted by mini-css-extract-plugin
module.exports = {"forgotPass":"login_forgotPass__skiTZ","orContainer":"login_orContainer__Lx6wm","errorBlock":"login_errorBlock__1RyEn","forgotSuccess":"login_forgotSuccess__3KW5i"};